import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Checkbox,
} from "@mui/material";
import { RefObject } from "react";
import { useTranslation } from "react-i18next";
import { GrappleModule } from "../../interfaces/api/GrappleModule";
import { Rototilt } from "../../interfaces/api/Rototilt";
import GrappleModules from "../Products/GrappleModules";
import Tiltrotators from "./Tiltrotators";

interface TiltrotatorsOptionalProps {
  grappleModules: GrappleModule[];
  isAccordianExpanded: boolean;
  isGrappleModuleNoneSelected: boolean;
  onAccordianClick(): void;
  onGrappleModuleChange(grappleModule: GrappleModule): void;
  onGrappleModuleNoneChange(): void;
  onTiltrotatorChange(rototilt: Rototilt): void;
  refGrappleModules: RefObject<HTMLDivElement>;
  selectedGrappleModule: GrappleModule;
  selectedTiltrotator: Rototilt;
  tiltrotators: Rototilt[];
}

const TiltrotatorsOptional = ({
  grappleModules,
  isAccordianExpanded,
  isGrappleModuleNoneSelected,
  onAccordianClick,
  onGrappleModuleChange,
  onGrappleModuleNoneChange,
  onTiltrotatorChange,
  refGrappleModules,
  selectedGrappleModule,
  selectedTiltrotator,
  tiltrotators,
}: TiltrotatorsOptionalProps) => {
  const { t } = useTranslation(["tiltrotator"]);

  return (
    <Accordion elevation={0} expanded={isAccordianExpanded}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel-tools-content"
        id="panel-tools-header"
        onClick={onAccordianClick}
      >
        <div className="toolOptionalHeader">
          <Checkbox checked={isAccordianExpanded} />
          <h3> {t("choosetiltrotator")}</h3>
        </div>
      </AccordionSummary>
      <AccordionDetails>
        <Tiltrotators
          onTiltrotatorChange={onTiltrotatorChange}
          selectedTiltrotator={selectedTiltrotator}
          tiltrotators={tiltrotators}
        />
        {selectedTiltrotator && (
          <GrappleModules
            grappleModules={grappleModules}
            isNoneSelected={isGrappleModuleNoneSelected}
            onChange={onGrappleModuleChange}
            onNoneChange={onGrappleModuleNoneChange}
            refGrappleModules={refGrappleModules}
            selectedGrappleModule={selectedGrappleModule}
          />
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default TiltrotatorsOptional;
